import type { Consent } from "~/types/consents";

const open = ref(false);
const consents = ref<Array<Consent>>([]);
const needsRerender = ref(false);

export const useConsentModal = () => {
  return {
    open,
    consents,
    needsRerender,
  };
};
